import React, { useState } from 'react'
import { Introduction } from './components/Introduction'
import { Questionaire } from './components/Questionaire'

export const Questions =() => {
  const [showLanding, setShowLanding] = useState(true)
  return (
    <>
      {showLanding ? (
        <Introduction setShowLanding={setShowLanding} />
      ) : (
        <Questionaire />
      )}
    </>
  )
}
